import { AxiosResponse } from 'axios';

import { normalizeSearchFiltersPayload } from 'utils/filters';

import axiosInstance from '../base';

import { normalizeReport } from './normalizers';
import { IReport, IReportData, IReportPayload, IReportsPath } from './types';

const reportsAPI = {
  async createReport({
    columns,
    needFilters = true,
    otherParams,
    pageFilters,
    path = '',
  }: IReportPayload): Promise<unknown> {
    const normalizedFilter = normalizeSearchFiltersPayload(pageFilters);

    const body = {
      value: columns,
    };

    const response = await axiosInstance.post(path, columns ? body : null, {
      params: {
        ...otherParams,
        searchQuery: needFilters ? normalizedFilter.search || null : undefined,
      },
    });

    return response.data;
  },

  async getReports({ path = '' }: IReportsPath): Promise<IReport[]> {
    const response = await axiosInstance.get(path);
    return response.data?.result?.map(normalizeReport);
  },

  async getReportFileLink({ id, path }: IReportData): Promise<string> {
    const response = await axiosInstance.get<Blob>(`${path}/${id}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },

  async deleteReport({ id, path }: IReportData): Promise<AxiosResponse> {
    const response = await axiosInstance.delete(`${path}/${id}`);
    return response.data;
  },
};

export default reportsAPI;
